module.exports = __webpack_public_path__ + "static/media/gradelink_logo.78b99b16.jpg";